import { AppConfig } from '../services/appConfig'
import { genericError, networkError } from '../widgets/modal'
import GridHandler from './handlers/gridHandler'

export default class Collection extends GridHandler {
  private _url: string
  private _pageSize: number

  async _onUrlParams({ url }: { url: string }) {
    this._url = decodeURIComponent(url)
    const urlParams = new URLSearchParams(this._url)
    this._pageSize = parseInt(urlParams.get('limit'), 0) ?? 0

    this._setState('NotReady')

    await this.getCollectionData()
  }

  async getCollectionData({ storeLastFocus } = { storeLastFocus: false }) {
    const data = await AppConfig.shared.experienceApi.getCollection(this._url)

    if (data?.error) {
      const error = data.isNetworkError ? networkError : genericError
      this.setModal(true, error)
      return
    }

    if (storeLastFocus) {
      this._lastFocusedRow = this.currentRow
      this._lastFocusedTile = this.currentTile
    }

    this.tvGridLayout.tvGridContainer.paginationUrl = this._url
    this.tvGridLayout.tvGridContainer.pageSize = this._pageSize

    if (this._lastPageNumber > 0) {
      this.tvGridLayout.tvGridContainer.pageNumber = this._lastPageNumber
      data.container.items = this._lastGridItems
    }

    this.tvGridLayout.data = data
    this.currentRow = this._lastFocusedRow ?? 0
    this.currentTile = this._lastFocusedTile ?? 0
    const originalyCoordinate = this.tvGridLayout.tvGridContainer.y
    this.tvGridLayout.tvGridContainer.y = this._lastYOffset ?? originalyCoordinate
    this._refocus()

    this._setState('Ready')
  }
}
